class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    FacetFiltersForm.syncSortSelectWidths();

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer =
      mobileForm?.closest('menu-drawer') || document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }

  static syncSortSelectWidths() {
    const sortSelects = document.querySelectorAll(
      '#FacetSortDrawerForm #SortBy, #FacetSortForm #SortBy, #FacetFiltersForm #SortBy, #SortBy-mobile'
    );
    const measurer = document.createElement('span');
    measurer.style.position = 'absolute';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';
    measurer.style.pointerEvents = 'none';
    measurer.style.left = '-9999px';
    document.body.appendChild(measurer);

    sortSelects.forEach((select) => {
      const selectedText = select.options?.[select.selectedIndex]?.text?.trim() || '';
      const computed = window.getComputedStyle(select);
      measurer.style.fontFamily = computed.fontFamily;
      measurer.style.fontSize = computed.fontSize;
      measurer.style.fontWeight = computed.fontWeight;
      measurer.style.letterSpacing = computed.letterSpacing;
      measurer.textContent = selectedText;
      const textWidth = Math.ceil(measurer.getBoundingClientRect().width);
      const caretRoom = 18;
      const totalWidth = Math.max(84, Math.min(280, textWidth + caretRoom));
      select.style.width = `${totalWidth}px`;
    });

    measurer.remove();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const target = event.target;
    /*
     * Use target.form (association via form="" attribute or ancestor form). Swatch
     * inputs are not DOM descendants of #FacetFiltersFormMobile, so closest('form')
     * is null and filters never applied. NOYRA moves the mobile form to document.body,
     * so it is no longer matched by querySelector('facet-filters-form form') — handle
     * #FacetFiltersFormMobile explicitly.
     */
    const form = target.form || target.closest('form');
    if (!form) return;

    if (form.id === 'FacetFiltersFormMobile') {
      this.onSubmitForm(this.createSearchParams(form), event);
      return;
    }

    const forms = [];
    sortFilterForms.forEach((f) => {
      if (f.id === 'FacetSortForm' || f.id === 'FacetFiltersForm' || f.id === 'FacetSortDrawerForm') {
        forms.push(this.createSearchParams(f));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.syncSortSelectWidths();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* NOYRA: Ensure mobile facets drawer opens when Filter and sort is tapped.
 * Moves the form to body so it's not constrained by ancestor transform/overflow. */
(function initMobileFacetsDrawer() {
  let facetsFormOriginalParent = null;

  function applyFacetsDrawerPositioning(form) {
    /* Use header group (includes announcement bar + header) so drawer starts below entire header area */
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const header = document.querySelector('.section-header');
    const headerEl = headerGroup || header;
    let headerBottom = 0;
    if (headerEl) {
      const headerRect = headerEl.getBoundingClientRect();
      const headerWrapper = header?.closest('.header-wrapper');
      const borderOffset = headerWrapper && headerWrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      headerBottom = Math.floor(headerRect.bottom - borderOffset);
      /* When scrolled, header can be off-screen. Clamp so overlay starts in viewport. */
      headerBottom = Math.max(0, Math.min(headerBottom, window.innerHeight));
      /* At top of page: ensure min so drawer never hides behind header/banner */
      if (headerRect.bottom > 0 && headerBottom < 48) {
        const cssHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
        headerBottom = Math.max(headerBottom, cssHeaderHeight || 56);
      }
    }
    document.documentElement.style.setProperty('--header-bottom-position', `${headerBottom}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    const inner = form.querySelector('.mobile-facets__inner');
    const headerMenuDrawer = document.getElementById('menu-drawer');
    if (headerMenuDrawer && inner) {
      const schemeClass = Array.from(headerMenuDrawer.classList).find((c) => c.startsWith('color-scheme-'));
      if (schemeClass) {
        Array.from(inner.classList).forEach((c) => { if (c.startsWith('color-scheme-')) inner.classList.remove(c); });
        inner.classList.add(schemeClass);
      }
    }
  }

  function openMobileFacetsDrawer(summary) {
    const details = summary.closest('details');
    const menuDrawer = summary.closest('menu-drawer');
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!details || !menuDrawer || !menuDrawer.classList.contains('mobile-facets__wrapper') || !form) return;
    if (details.hasAttribute('open')) return;

    details.setAttribute('open', '');
    details.classList.add('menu-opening');
    summary.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden-mobile', 'facets-drawer-open');

    /* Move form to body so position:fixed works full viewport (no ancestor transform/overflow) */
    if (form.parentElement && form.parentElement !== document.body) {
      facetsFormOriginalParent = form.parentElement;
      document.body.appendChild(form);
    }
    applyFacetsDrawerPositioning(form);

    /* Defer noyra-facets-open so browser paints closed state first – enables slide-from-left like burger menu */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        form.classList.add('noyra-facets-open');
        if (typeof window.trapFocus === 'function') {
          window.trapFocus(form, form.querySelector('button.mobile-facets__close-inner, .mobile-facets__close-inner') || summary);
        }
      });
    });
  }

  function closeMobileFacetsDrawer() {
    const summary = document.querySelector('menu-drawer.mobile-facets__wrapper summary.mobile-facets__open-wrapper');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    const form = document.getElementById('FacetFiltersFormMobile');
    if (form && facetsFormOriginalParent && form.parentElement === document.body) {
      form.classList.remove('noyra-facets-open');
      facetsFormOriginalParent.appendChild(form);
      facetsFormOriginalParent = null;
    }
    document.body.classList.remove('facets-drawer-open');
  }

  function setupDetailsObserver() {
    const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!menuDrawer) return;
    const details = menuDrawer.querySelector('details.mobile-facets__disclosure');
    if (!details) return;
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;

    const observer = new MutationObserver(function () {
      if (details.hasAttribute('open') && details.classList.contains('menu-opening')) {
        const summary = details.querySelector('summary.mobile-facets__open-wrapper');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        document.body.classList.add('facets-drawer-open');
        if (form.parentElement && form.parentElement !== document.body) {
          facetsFormOriginalParent = form.parentElement;
          document.body.appendChild(form);
        }
        applyFacetsDrawerPositioning(form);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            form.classList.add('noyra-facets-open');
          });
        });
      } else {
        closeMobileFacetsDrawer();
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  function attachMobileFacetsHandler() {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    const menuDrawer =
      form.closest('menu-drawer') || document.querySelector('menu-drawer.mobile-facets__wrapper');
    const summary = menuDrawer?.querySelector('.mobile-facets__open-wrapper');
    if (!summary || summary.dataset.noyraFacetsBound) return;

    summary.dataset.noyraFacetsBound = '1';
    summary.addEventListener('click', function (e) {
      const details = summary.closest('details');
      if (details && !details.hasAttribute('open')) {
        e.preventDefault();
        e.stopPropagation();
        openMobileFacetsDrawer(summary);
      }
    }, { capture: true });
    summary.addEventListener('touchend', function (e) {
      const details = summary.closest('details');
      if (details && !details.hasAttribute('open')) {
        e.preventDefault();
        openMobileFacetsDrawer(summary);
      }
    }, { passive: false, capture: true });
  }

  function handleCloseInnerClick(e) {
    const btn = e.target.closest('.mobile-facets__close-inner, .mobile-facets__overlay');
    if (!btn) return;
    const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    const summary = menuDrawer?.querySelector('summary');
    if (summary) {
      e.preventDefault();
      summary.click();
    }
  }

  function attachSwipeToClose() {
    const form = document.getElementById('FacetFiltersFormMobile');
    const panel = form?.querySelector('.mobile-facets__inner');
    if (!form || !panel || panel.dataset.noyraSwipeBound) return;
    panel.dataset.noyraSwipeBound = '1';

    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    panel.addEventListener(
      'touchstart',
      function (event) {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchEndX = touch.clientX;
        touchEndY = touch.clientY;
      },
      { passive: true }
    );

    panel.addEventListener(
      'touchmove',
      function (event) {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        touchEndX = touch.clientX;
        touchEndY = touch.clientY;
      },
      { passive: true }
    );

    panel.addEventListener('touchend', function () {
      const isOpen = form.classList.contains('noyra-facets-open');
      if (!isOpen) return;
      const deltaX = touchEndX - touchStartX;
      const deltaY = Math.abs(touchEndY - touchStartY);
      const isHorizontalSwipe = Math.abs(deltaX) > 60 && deltaY < 50;
      const isCloseGesture = deltaX < -60;
      if (isHorizontalSwipe && isCloseGesture) {
        const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
        const summary = menuDrawer?.querySelector('summary');
        if (summary) summary.click();
      }
    });
  }

  function init() {
    document.addEventListener('click', handleCloseInnerClick);
    attachMobileFacetsHandler();
    setupDetailsObserver();
    attachSwipeToClose();
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const menuDrawer =
        mobileForm.closest('menu-drawer') || document.querySelector('menu-drawer.mobile-facets__wrapper');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
